// DrimifyProvider.jsx
import React, { createContext, useState, useContext, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import DrimifyWidget from "./DrimifyWidget";
import { useMutation, useQuery } from "@tanstack/react-query";
import { apiVoissa } from "../api";
import { usePostHog } from 'posthog-js/react';

const DrimifyContext = createContext();

export const useDisplayDrimify = (appId, queryOptions = {})=>{
  const {data, isFetching} = useQuery(['game-service-show', appId], ()=>apiVoissa.get('/game-service/show?appId=' + appId), {
    staleTime : 60 * 1000 * 5,
    ...queryOptions
  });
  return {show : data?.show, isFetching};
}

export const useDrimify = (url, appId, options = {}) => {
  const { openDrimify: originalOpenDrimify, closeDrimify, isOpen } = useContext(DrimifyContext);
  const posthog = usePostHog();
  
  const { onUnavailable, disableCheck } = options;

  const _originalOpenDrimify = useCallback(() => {
    posthog.capture('drimify_game_start');
    originalOpenDrimify(url, options);
  }, [posthog, originalOpenDrimify, url, options]);
  
  const {mutate, isLoading} = useMutation(()=>apiVoissa.get('/game-service/show?appId=' + appId),{
    onSuccess: (data) => {
      if(!!data?.show){
        _originalOpenDrimify();
      }
      else if (typeof options.onUnavailable === 'function'){
        options.onUnavailable();
      }
      else{
        console.warn("Drimify is unavailable and no onUnavailable handler provided.");
      }
    }
  });
  
  const openDrimify = useCallback(() => {
    if(disableCheck){
      _originalOpenDrimify();
      return;
    }
    mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableCheck, mutate, onUnavailable, _originalOpenDrimify, url]);
  
  return { openDrimify,originalOpenDrimify, closeDrimify, isOpen, isLoading  };
};

export const DrimifyProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [props, setProps] = useState(null);
  
  const openDrimify = useCallback((drimifyUrl, options = {}) => {
    setProps({ url: drimifyUrl, onComplete: options.onComplete });
    setIsOpen(true);
  }, []);
  
  const closeDrimify = useCallback(() => {
    setIsOpen(false);
    setProps(null);
  }, []);
  
  useEffect(() => {
    if (isOpen) {
      const original = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [isOpen]);
  
  return (
    <DrimifyContext.Provider value={{ isOpen, openDrimify, closeDrimify }}>
    {children}
    {isOpen && props &&
      createPortal(
        <DrimifyWidget url={props.url} onClose={closeDrimify} onComplete={props.onComplete} />,
        document.body
      )
    }
    </DrimifyContext.Provider>
  );
};

// {
//     "type": "complete",
//     "data": {
//         "credentials": {
//             "isPreviewMode": null,
//             "projectSlug": "xKcOg4Ef",
//             "projectID": 396225,
//             "projectLanguage": "fr",
//             "projectName": "Tourne la roue pour débloquer une surprise 🎉 ",
//             "projectType": "wheeloffortune",
//             "publisherID": null,
//             "sessionID": "Session_599497c6-afda-44dd-83be-410f2f754ea9",
//             "ref": "direct"
//         },
//         "gameMetrics": {
//             "completed": true,
//             "userWon": true,
//             "prizeID": "d745f55fe0720683c1ec39d64ceacbd9e09f2fe3",
//             "prizeRef": null,
//             "prizeImage": null,
//             "prizeName": "- 30% sur le premium"
//         }
//     }
// }